import { render } from "./MoveCampaign.vue?vue&type=template&id=46e671af"
import script from "./MoveCampaign.vue?vue&type=script&lang=js"
export * from "./MoveCampaign.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__